import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import { lowercase } from 'ember-cli-string-helpers';
import {
  HdsTextDisplay,
  HdsTextBody,
  HdsLinkInline,
  HdsCopySnippet,
  HdsSeparator,
} from '@hashicorp/design-system-components/components';
import { FlexGrid } from 'core/components';
import { boxPadding } from 'core/modifiers';

const Enabled = <template>
  <HdsTextDisplay @size="300" @tag="h3" {{boxPadding "sm 0 md 0"}}>
    {{t "components.scim.enabled.title"}}
  </HdsTextDisplay>
  <HdsTextBody @size="200" @tag="p" {{boxPadding "0 0 xl 0"}}>
    {{t "components.scim.enabled.description"}}
    <HdsLinkInline
      @icon="arrow-right"
      @route={{concat
        "cloud.orgs.detail.settings.sso."
        (lowercase @ssoType)
        ".configure"
      }}
      data-test-scim-enabled-edit-default-role
    >
      {{t "components.scim.enabled.edit-default-role"}}
    </HdsLinkInline>
  </HdsTextBody>
  <HdsTextDisplay @size="200" @tag="h4" @weight="semibold">
    {{t "components.scim.enabled.action.title"}}
  </HdsTextDisplay>
  <HdsTextBody @size="200" @tag="p">
    {{t "components.scim.enabled.action.description"}}
  </HdsTextBody>
  <FlexGrid as |G|>
    <G.Item @xs="10" @sm="10" @md="10" @lg="7">
      <HdsCopySnippet
        @textToCopy={{@scimTenantUrl}}
        data-test-scim-enabled-copy-snippet
      />
    </G.Item>
  </FlexGrid>
  <HdsSeparator />
</template>;

export default Enabled;
